'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createConnector = require('../core/createConnector');

var _createConnector2 = _interopRequireDefault(_createConnector);

var _highlight = require('../core/highlight');

var _highlight2 = _interopRequireDefault(_highlight);

var _highlightTags = require('../core/highlightTags.js');

var _highlightTags2 = _interopRequireDefault(_highlightTags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var highlight = function highlight(_ref) {
  var attributeName = _ref.attributeName,
      hit = _ref.hit,
      highlightProperty = _ref.highlightProperty;
  return (0, _highlight2.default)({
    attributeName: attributeName,
    hit: hit,
    preTag: _highlightTags2.default.highlightPreTag,
    postTag: _highlightTags2.default.highlightPostTag,
    highlightProperty: highlightProperty
  });
};

/**
 * connectHighlight connector provides the logic to create an highlighter
 * component that will retrieve, parse and render an highlighted attribute
 * from an Algolia hit.
 * @name connectHighlight
 * @kind connector
 * @category connector
 * @providedPropType {function} highlight - the function to retrieve and parse an attribute from a hit. It takes a configuration object with 3 attribute: `highlightProperty` which is the property that contains the highlight structure from the records, `attributeName` which is the name of the attribute to look for and `hit` which is the hit from Algolia. It returns an array of object `{value: string, isHighlighted: boolean}`.
 * @example
 * const CustomHighlight = connectHighlight(({highlight, attributeName, hit, highlightProperty) => {
 *   const parsedHit = highlight({attributeName, hit, highlightProperty});
 *   return parsedHit.map(part => {
 *     if(part.isHighlighted) return <em>{part.value}</em>;
 *     return part.value:
 *   });
 * });
 */

var _default = (0, _createConnector2.default)({
  displayName: 'AlgoliaHighlighter',

  propTypes: {},

  getProvidedProps: function getProvidedProps() {
    return { highlight: highlight };
  }
});

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(highlight, 'highlight', 'src/connectors/connectHighlight.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/connectors/connectHighlight.js');
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/connectors/connectHighlight.js
// module id = 313
// module chunks = 0